<template>
    <div class="mainWrap">
        <!-- <frontslider table="2recruit_settings" app="2recruit" ref="slidercomp" style="display:block;"></frontslider> -->


        <div id="logins">

            <link href="https://fonts.googleapis.com/css?family=Roboto:100,400,800" rel="stylesheet" />
            <!--  <h1>Login</h1>
        <input type="text" name="username" v-model="input.username" placeholder="Username" />
        <input type="password" name="password" v-model="input.password" placeholder="Password" />
        <button type="button" v-on:click="login()">Login</button> -->

            <div class="fs-container">
                <div class="fs-container__bg"></div>
                <div class="content">
                    <div class="content-login">
                        <div class="content__pane init2">

                            <img class="logo" :src="pathLogo" style="max-width: 100px" />

                            <form name="login" id="login-form" novalidate="" method="POST" v-on:submit.prevent
                                style="max-width: 286px;">
                                <div class="flex-container">
                                    <input type="hidden" id="t_login" name="t_login" value="NO_QRCODE" />

                                    <div id="classic-login">
                                        <div class="group filled">
                                            <input v-model="input.email" id="user" class="user" required="" name="user"
                                                type="text" value="" placeholder="Username" />

                                            <span class="highlight"></span>
                                            <span class="bar"></span>
                                            <label>
                                                <img src="@/assets/loginstart/img/user.png" />
                                                <span class="label__text label__text--hidden">Username</span>
                                            </label>
                                        </div>

                                        <div class="group filled" style="margin-bottom: 0px">
                                            <input ref="currPass" v-model="input.password" id="password"
                                                class="password" required="" name="password" type="password" value="" />
                                            <span class="highlight"></span>
                                            <span class="bar"></span>
                                            <img @click="showPassword" class="showpwd"
                                                src="@/assets/icons8-eye-24.png" />

                                            <label>
                                                <span class="label__text label__text--hidden">Password</span>
                                                <img src="@/assets/loginstart/img/pwd.png" />
                                            </label>

                                            <a id="forgotPass" @click="recover">
                                                Password dimenticata?
                                            </a>


                                        </div>



                                    </div>

                                    <div id="qr-code-wrapper">
                                        <button type="button" id="qr-code-btn">
                                            <span class="tooltiptext">Login with QR-Code</span>

                                            <img src="@/assets/loginstart/img/qr-btn-alpha.png" alt="submit" />
                                        </button>
                                    </div>

                                    <!-- added code -->

                                    <div class="container" id="qr-login" style="display: none">
                                        <div>
                                            <a class="button" id="resetButton">Back</a>
                                        </div>

                                        <div>
                                            <video id="video" width="300" height="200"
                                                style="border: 1px solid gray"></video>
                                        </div>

                                        <div id="sourceSelectPanel" style="display: none">
                                            <label for="sourceSelect">Change video source:</label>
                                            <select id="sourceSelect" style="max-width: 400px"></select>
                                        </div>

                                        <div style="text-align: left; display: none">
                                            <label>Result:</label>
                                            <pre><code id="result"></code></pre>
                                        </div>
                                    </div>

                                    <!-- end added code -->
                                </div>

                                <div id="lang-select" class="group select">
                                    <div class="lang__field">
                                        <span class="lang__selected"><img src="@/assets/loginstart/img/uk.png"
                                                class="flag-img" /></span>
                                        <label class="select__label">
                                            <img src="@/assets/loginstart/img/language.png" />
                                        </label>
                                        <div class="lang__options">
                                            <div data-value="EN" class="lang__option">
                                                <img src="@/assets/loginstart/img/uk.png" class="flag-img" />
                                            </div>
                                            <div data-value="IT" class="lang__option">
                                                <img src="@/assets/loginstart/img/italy.png" class="flag-img" />
                                            </div>
                                        </div>
                                    </div>
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                </div>

                                <div id="otp-select" class="group select">
                                    <div class="otp__field">
                                        <span class="otp__selected">
                                            <div class="otp-text">Email</div>
                                            <img src="@/assets/loginstart/img/mail.png" class="otp-img" />
                                        </span>
                                        <label class="select__label">
                                            <div class="text-label">OTP</div>
                                            <img src="@/assets/loginstart/img/token.png" />
                                        </label>
                                        <div class="otp__options">
                                            <div data-value="MAIL" class="otp__option">
                                                <div class="otp-text">Email</div>
                                                <img src="@/assets/loginstart/img/mail.png" class="otp-img" />
                                            </div>
                                            <div data-value="SMS" class="otp__option">
                                                <div class="otp-text">Sms</div>
                                                <img src="@/assets/loginstart/img/sms.png" class="otp-img" />
                                            </div>

                                            <div data-value="Auth" class="otp__option">
                                                <div class="otp-text">Auth</div>
                                                <img src="@/assets/loginstart/img/auth.png" class="otp-img" />
                                            </div>
                                        </div>
                                    </div>
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                </div>

                                <button class="
                                                                                                              button button--block button--outline button--primary
                                                                                                              modal-trigger
                                                                                                            "
                                    id="login-button" value="login" v-on:click="login()">
                                    <div class="button--text">Login</div>
                                    <div class="spinner hidden">
                                        <div class="holder">
                                            <div class="preloader">
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                            </div>
                                        </div>
                                    </div>
                                </button>

                                <img src="@/assets/back-jobmule.png" class="clBtnBack" id="btnBackCareers" title="Back"
                                    @click="goBack()" />

                                <div class="clRegistrati">Registrati</div>


                                <rise-loader v-if="showSpinner" :size="'20px'" :color="'#01adff'" />
                                <!-- <div class="info info--error info--hidden">
                Devi inserire sia il nome utente sia la password
              </div> -->
                            </form>
                        </div>
                    </div>
                </div>
            </div>


        </div>


        <div class="contpopupotplogin" style="display:none">

            <template>
                <modal name="popupOtpLogin" :clickToClose="false" :width="262" :height="221">


                    <v-row>

                        <v-col cols="12" md="12"
                            style="margin-top:10px!important;font-weight:bold;margin-left:10px;font-size:12px">

                            Codice OTP inviatoLe via mail

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <v-text-field type="password" v-model="valueOtpLogin" label="" id="fldValueOtpLogin">
                            </v-text-field>

                        </v-col>

                    </v-row>

                    <v-row v-if="showResend">

                        <v-col cols="12" md="12" style="display: flex;
                                            justify-content: center;
                                            padding-top: 0px!important;
                                            margin-top: 0px!important;
                                            font-size: 12px!important;">

                            <div>OTP non ricevuto ? </div>
                            <div style="font-weight: bold;
                                            margin-left: 10px;
                                            cursor: pointer;" class="clReinviaOtp">Reinvia</div>

                        </v-col>

                    </v-row>


                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-otp-login" contain
                                    src="@/assets/btn_cancel3_jobmule.png" max-width="30" max-height="30"
                                    style="cursor:pointer;color:black;margin-right:10px" transition="scale-transition"
                                    title="Annulla" @click="btnCancelOtpLogin" />

                                <v-img alt="" class="btn-confirm-otp-login" contain
                                    src="@/assets/btn_confirm3_jobmule.png" max-width="30" max-height="30"
                                    style="cursor:pointer" transition="scale-transition" title="Conferma"
                                    @click="btnConfirmOtpLogin" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>






    </div>
</template>

<style lang="css" scoped>
@import "./../assets/loginstart/style.css";
</style>

<script>


import $ from 'jquery';
import RiseLoader from "vue-spinner/src/RiseLoader.vue";

import router from ".././router";


import apiotp from "../utils/otp/apiotp";


export default {

    components: {
        RiseLoader
    },

    updated() { },

    mounted: function () {


        window.sendOtp = 1;


        window.myVal = "";

        window.nomeAzienda = "";


        var loggedIn = this.$cookies.get('token');

        if ((location.hostname == "testheyjob.emtool.eu") || (location.hostname == "presenze.stipendio.net")) {
            this.showEmt = false;
            this.showNext3 = true;
        }



        if (loggedIn) {
            router.push({
                path: "/dash"
            });
        }
        console.log("Ciao: " + this.userLogged);


        this.pathLogo = window.$cookies.get("url_logo_conf");

        console.log("URL LOGO: ", this.pathLogo);

        var pointerVue = this;

        $(document).ready(function () {


            $('body').on('click', '.clRegistrati', function (event) {
                event.preventDefault();

                setTimeout(() => {

                    router.push({
                        path: "/registerCompany"
                    });

                }, 200);


            });





            $('body').on('click', '.clReinviaOtp', function (event) {
                event.preventDefault();

                pointerVue.showResend = false;

                pointerVue.$modal.hide('popupOtpLogin');

                window.sendOtp = 1;


                setTimeout(() => {

                    pointerVue.getOtpLogin();

                }, 300);


            });



        });



        //        this.$cookie.get('jwt_token')
        //console.log ( this.$cookie.getAll() );
        //$cookie.set('cookie_name', 'cookie_value');
        //window.$cookie.set('test', 'Hello world!', 1);
        //  console.log (window.$cookies.getCookie()  );
        // const username = this.$cookies.get("username");
        //console.log(username);
        //        this.$cookie.getAll()
    },
    name: "Login",

    // data:

    data() {
        return {

            mailUser: "",

            showResend: true,

            valueOtpLogin: "",


            pathLogo: "",

            dialogRegister: true,

            showEmt: true,
            showNext3: false,

            notifications: false,
            sound: true,
            widgets: false,

            showSpinner: false,
            input: {
                username: "",
                password: "",
            },
        };
    },
    methods: {

        getUrlLoginApiGo: function () {

            let result = "";

            if (location.hostname == "localhost") {
                result = "http://localhost:4007/checkLoginJobmule";
            }

            if (location.hostname != "localhost") {

                result = "https://filestransfer.it:4007/checkLoginJobmule";

            }

            return result;

        },

        validate() {

            console.log("USERNAME: ", this.input.email);
            console.log("PASSWORD: ", this.input.password);


            var errore = "";

            if (this.input.email == "") {
                errore = "Username richiesta";
            }

            if (errore == "") {
                if (this.input.email == undefined) {
                    errore = "Username richiesta";
                }
            }

            if (errore == "") {
                if (this.input.password == "") {
                    errore = "Password richiesta";
                }
            }

            if (errore == "") {
                if (this.input.password == undefined) {
                    errore = "Password richiesta";
                }
            }


            if (errore == "") {

                console.log("ok");

                this.showSpinner = true;
                this.getCookie();


                this.loginAction(this.input.email, this.input.password);


            }
            else {

                this.$swal.fire({
                    text: errore,
                    icon: "error",
                    showConfirmButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                });


            }



        },

        getUrlDomainApi: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = location.protocol + "//emtool.local/";
            }

            if (location.hostname != "localhost") {

                result = "https://companysupport.eu/";

            }

            return result + "api/" + nome_metodo;

        },

        getUrlDomain: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = location.protocol + "//emtool.local/";
            }

            if (location.hostname != "localhost") {

                result = "https://companysupport.eu/";

            }

            return result + nome_metodo;

        },

        getUrlDomainGo: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = "http://localhost:4007/";
            }

            if (location.hostname != "localhost") {

                result = "https://filestransfer.it:4007/";

            }

            return result + nome_metodo;

        },


        recover: function () {
            // this.showSpinner = true;



            var spinner = $("#bspinner");
            var loginButton = $("#login-button");

            var API_URL = this.getUrlDomainGo("resetPwdJobmuleApp");

            var that = this;

            this.$swal
                .fire({
                    title: "Resetta password",
                    html: "Inserisci la tua username",
                    /*  icon: "warning", */
                    showCancelButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_jobmule.png' />",
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    },

                    input: "text",

                    inputAttributes: {
                        autocapitalize: "off",
                    },

                    preConfirm: (username) => {
                        // console.log(username);

                        // show spinner && disable button
                        spinner.removeClass("vhidden");
                        that.showSpinner = true;

                        loginButton.prop("disabled", true);

                        var body = {
                            user: username,
                            soggetto: "azienda",
                            portale: "jobmule",
                            product: 'Jobmule'
                        };

                        console.log(body);
                        // call the service
                        $.ajax({
                            type: "POST",
                            url: API_URL,
                            data: body,
                            success: function (resultData) {

                                console.log("RESULTDATA: ", resultData);

                                // hide spinner && enable button
                                spinner.addClass("vhidden");
                                that.showSpinner = false;

                                loginButton.prop("disabled", false);

                                if (resultData.Result == "OK") {
                                    var message;

                                    message = "Verifica la tua E-Mail";

                                    //open ok modal


                                    that.$swal.fire({
                                        icon: "success",
                                        title: message,
                                        showConfirmButton: true,
                                        confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                                    });
                                } else {
                                    var errorMessage;

                                    switch (resultData.Result) {
                                        case "USER_NOT_FOUND":
                                            errorMessage = "Utente non trovato";
                                            break;
                                        default:
                                            errorMessage = "Utente non trovato";
                                    }

                                    that.$swal.fire({
                                        text: errorMessage,
                                        icon: "error",
                                        showConfirmButton: true,
                                        confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                                    });

                                    that.showSpinner = false;
                                }



                            },
                            error: function () {
                                // hide spinner && enable login button
                                spinner.addClass("vhidden");
                                loginButton.prop("disabled", false);
                                that.showSpinner = false;
                                //  errorHandler(event);
                            },
                        });
                    },

                });


            setTimeout(() => {


                $(".swal2-input").val(that.input.username);


            }, 500);





        },


        getUrlLoginApi: function () {

            let result = "";

            if (location.hostname == "localhost") {
                result = location.protocol + "//emtool.local/";
            }

            if (location.hostname != "localhost") {

                result = "https://companysupport.eu/";

            }

            return result + "public/utility/checkLoginJM.php";

        },

        btnCancelOtpLogin: function () {

            this.$modal.hide('popupOtpLogin');


        },

        btnConfirmOtpLogin: function () {


            if (this.valueOtpLogin != "") {

                console.log("OTP INP: ", this.valueOtpLogin);
                console.log("ENC OTP INP: ", btoa(this.valueOtpLogin));

                if (window.myVal == btoa(this.valueOtpLogin)) {

                    this.$modal.hide('popupOtpLogin');



                    // this.loginAction2(this.input.email, this.input.password);

                    setTimeout(() => {






                        var uname = this.input.email;
                        const args = [uname, true, ['bar', 5], {
                            foo: 'baz'
                        }];
                        try {
                            console.log("entering user");
                            window.flutter_inappwebview.callHandler('setLoggedUser', ...args);

                        } catch (error) {
                            // alert(error);
                        }

                        //   this.$root.$children[0].curDipTop = respo.namesurname;
                        this.$root.$children[0].curDipTop = window.nomeAzienda;

                        //update menu after login
                        this.$root.$children[0].changeMenu();
                        //Load companies array
                        //this.$root.$children[0].syncMonth();
                        //this.$root.$children[0].syncGroups();

                        this.$root.$children[0].refreshMenu();


                        setTimeout(() => {
                            router.push({
                                path: "/dash"
                            });

                        }, 300);








                    }, 1);


                }
                else {

                    this.$swal({
                        icon: "error",
                        text: "Valore OTP non corretto",
                        showConfirmButton: false,
                        timer: 2000
                    });


                }



            }
            else {

                this.$swal({
                    icon: "error",
                    text: "Specificare un  valore dell'OTP",
                    showConfirmButton: false,
                    timer: 2000
                });

            }



        },



        btnConfirmOtpLoginOld: function () {


            if (this.valueOtpLogin != "") {

                console.log("OTP INP: ", this.valueOtpLogin);
                console.log("ENC OTP INP: ", btoa(this.valueOtpLogin));

                if (window.myVal == btoa(this.valueOtpLogin)) {

                    this.$modal.hide('popupOtpLogin');

                    setTimeout(() => {

                        router.push({
                            path: "/CvCandidato"
                        });

                    }, 300);


                }
                else {

                    this.$swal({
                        icon: "error",
                        text: "Valore OTP non corretto",
                        showConfirmButton: false,
                        timer: 2000
                    });


                }



            }
            else {

                this.$swal({
                    icon: "error",
                    text: "Specificare un  valore dell'OTP",
                    showConfirmButton: false,
                    timer: 2000
                });

            }



        },

        getOtpLogin: async function () {

            var that = this;


            window.myVal = "";

            that.showSpinner = true;


            var response = await apiotp.generateOTPAndSendMailLoginGo(
                that.mailUser,
                'jobmule',
                'login_azienda',
                0
            ).then((res) => {

                that.showSpinner = false;

                console.log("res from generateOTPAndSendMailLoginGo", res);

                window.myVal = res.data.Result;


                setTimeout(() => {

                    that.showResend = true;

                    that.valueOtpLogin = "";

                    $(".contpopupotplogin").show();

                    this.$modal.show('popupOtpLogin');

                    setTimeout(() => {

                        $("#fldValueOtpLogin").focus();

                    }, 300);


                }, 200);





            }).catch(err => {
                that.showSpinner = false;
                // that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );






        },


        getOtpLoginOld: async function () {

            var that = this;


            window.myVal = "";


            if (window.sendOtp == 1) {

                window.sendOtp = 0;


                that.showSpinner = true;
                // that.$root.$children[0].showProgress = true;

                var response = await apiotp.generateOTPAndSendMailLogin(
                    that.mailUser,
                    'jobmule',
                    'login_azienda',
                    0
                ).then((res) => {

                    that.showSpinner = false;
                    //  that.$root.$children[0].showProgress = false;
                    console.log("res from generateOTPAndSendMailLogin", res);

                    window.myVal = res.data.Result;


                    setTimeout(() => {

                        that.showResend = true;

                        that.valueOtpLogin = "";

                        $(".contpopupotplogin").show();

                        this.$modal.show('popupOtpLogin');

                        setTimeout(() => {

                            $("#fldValueOtpLogin").focus();

                        }, 300);


                    }, 200);





                }).catch(err => {
                    that.showSpinner = false;
                    // that.$root.$children[0].showProgress = false;
                    console.log(err);
                    var msg = err.response.data.Error;

                    that.$swal({
                        icon: "error",
                        text: msg,
                        showConfirmButton: false,
                        timer: 8000
                    });
                    console.log("Errori", "Non è stato possibile eliminare i dati");
                    console.log("response", response);

                }

                );



            }









        },



        goBack: function () {

            console.log("GO BACK");

            this.$root.$children[0].logout();

            var v_page = window.$cookies.get("page_go_back");

            console.log("PAGE CALL: ", v_page);

            router.push({ path: '/' + v_page }).catch(() => { });


        },

        showPassword() {

            var currPass = this.$refs.currPass;
            if (currPass.type === "password") {
                currPass.type = "text"
                currPass.btnText = "Hide Password"
            } else {
                currPass.type = "password"
                currPass.btnText = "Show Password"
            }
        },


        getCookie() {
            this.$cookies.set("cookie-consent-performance", "yes");

            //  this.$swal('You are logged in!!!');

            //   console.log(Vue.cookie.get('token'));

            // it gets the cookie called `username`
            /* const username = this.$cookies.get("username");
            console.log(username); */
        },


        loginAction: async function (v_username, v_password) {
            //const auth = { user: this.username, password: this.password };
            // Correct username is 'foo' and password is 'bar'
            //const url = "https://app.emtool.eu/api/emt/checkLogin";


            this.showSpinner = true;

            const url = this.getUrlLoginApiGo();

            this.success = false;
            this.error = null;

            let formData = new FormData();
            formData.append("user", v_username);
            formData.append("password", v_password);
            formData.append("productid", "Jobmule");
            formData.append("soggetto", "azienda");
            formData.append("portale", "jobmule");
            formData.append("log_access", 1);

            var login = this.input.username;
            console.log(login);

            try {
                await this.axios
                    .post(url, formData, {
                        "content-type": "application/json"
                    })
                    .then(async (result) => {
                        var respo = result.data;
                        this.success = true;
                        console.log("RESPO: ", respo);


                        if (respo.Result == "OK") {

                            if (respo.product_enable == 1) { // prodotto abilitato

                                setTimeout(() => {

                                    this.showSpinner = false;
                                    //this.$swal("You are logged in!!!");

                                    window.$cookies.set("a", respo.a, "9y");
                                    window.$cookies.set("b", respo.b, "9y");


                                    window.$cookies.set("token", respo.token, "9y");
                                    window.$cookies.set("system", respo.system, "9y");
                                    window.$cookies.set("token_system", respo.token_system, "9y");
                                    window.$cookies.set("username", respo.username, "9y");
                                    window.$cookies.set("user_id", respo.user_id, "9y");
                                    window.$cookies.set("namesurname", respo.namesurname, "9y");
                                    window.$cookies.set("is_ebadge", respo.is_ebadge, "9y");
                                    window.$cookies.set("is_cust_supp", respo.isCustOrSupplier.length, "9y");
                                    window.$cookies.set("is_agila", respo.is_agila, "9y");
                                    window.$cookies.set("models", respo.models, "9y");
                                    window.$cookies.set("product_permissions", respo.product_permissions, "9y");
                                    window.$cookies.set("cid", respo.cid, "9y");
                                    window.$cookies.set("is_invite_cespiti", 0, "9y");
                                    window.$cookies.set("companyid_rich_hol", "", "9y");
                                    window.$cookies.set("resourceid_rich_hol", "", "9y");
                                    window.$cookies.set("idrichesta_rich_hol", "", "9y");
                                    window.$cookies.set("sel_filter_idrichiesta_storico_ferie", "", "9y");
                                    window.$cookies.set("nome_azienda_utente", respo.nome_azienda, "9y");
                                    window.$cookies.set("tipo_utente", "Azienda", "9y");
                                    window.$cookies.set("is_pwd_changed_once", respo.IsChanged, "9y");

                                    window.nomeAzienda = respo.nome_azienda;

                                    this.mailUser = respo.email;

                                }, 1);


                                if (respo.IsChanged == 0) { // password da cambiare

                                    setTimeout(() => {
                                        router.push({
                                            path: "/changepasswordinitial"
                                        });

                                    }, 300);

                                }

                                if (respo.IsChanged == 1) { // password valida

                                    console.log("ok");


                                    setTimeout(() => {

                                        this.getOtpLogin();

                                    }, 1);



                                }


                            }
                            else {

                                this.$swal({
                                    icon: "error",
                                    text: "Prodotto non abilitato",
                                    showConfirmButton: false,
                                    timer: 3000
                                });

                                this.showSpinner = false;

                            }


                        }
                        else {

                            this.success = false;
                            this.$swal({
                                icon: "error",
                                text: respo.ErrDetails,
                                confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_careers.png' />",
                                cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_careers.png' />",
                                showCancelButton: false,
                                customClass: {
                                    cancelButton: 'order-1',
                                    confirmButton: 'order-2',
                                }
                            });

                            this.showSpinner = false;

                        }







                    });
            } catch (err) {
                this.success = false;
                console.log(err.message);
                this.$swal({
                    icon: "error",
                    text: "Credenziali sbagliate",
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_careers.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_careers.png' />",
                });

                this.showSpinner = false;
                //  console.log(   response);

                //   this.error = err.message;
            }
        },





        login() {
            this.getCookie();


            this.validate();


        },
    },
};
</script>

<style scoped>
#qr-code-wrapper,
#lang-select,
#otp-select {
    display: none;
}

#login {
    width: auto;
    border: 1px solid #cccccc;
    background-color: #ffffff;
    margin: auto;
    /*   margin-top: 200px; */
    padding: 20px;
}

#nav,
.v-sheet {
    display: none;
}


img.showpwd {
    position: absolute;
    /* right: 0px; */
    top: 14px;
    right: 0px;
    max-width: 22px;
    cursor: pointer;

}
</style>


<style>
#fldValueOtpLogin {
    text-align: center !important;
}

.v-text-field input {
    font-size: 12px !important;
}

.clRegistrati {
    font-size: 14px;
    cursor: pointer;
    font-family: 'Roboto', Arial, Helvetica, sans-serif !important;
}



::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #c8d4da;
    opacity: 1;
    /* Firefox */
}



.clBtnBack {
    width: 40px;
    margin-top: 45px;
    cursor: pointer;
}
</style>